import * as Properties from "./Properties";

export const fieldPropertyMap = {
  TextField: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.DisplayNameHorizontallyProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.IsEditableProperty,
      Properties.DefaultValueProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.MaxLengthProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DefaultValueProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.MaxLengthProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DefaultValueProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.MaxLengthProperty,
      Properties.WidthProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  List: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.IsEditableProperty,
      Properties.DisplayNameHorizontallyProperty,
      Properties.DatasetProperty,
      Properties.DefaultListValueProperty,
      Properties.ParentFieldNameProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.ExclusionFilterProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.SelectionModeProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DatasetProperty,
      Properties.DefaultListValueProperty,
      Properties.ParentFieldNameProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.ExclusionFilterProperty,
      Properties.SelectionModeProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DatasetProperty,
      Properties.DefaultListValueProperty,
      Properties.ParentFieldNameProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.WidthProperty,
      Properties.ExclusionFilterProperty,
      Properties.SelectionModeProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  TextArea: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DisplayNameHorizontallyProperty,
      Properties.IsEditableProperty,
      Properties.DefaultValueProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.MaxLengthProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DefaultValueProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.MaxLengthProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DefaultValueProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.MaxLengthProperty,
      Properties.WidthProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Numeric: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DisplayNameHorizontallyProperty,
      Properties.IsEditableProperty,
      Properties.DefaultNumericValueProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.MaxMinProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.NumericFormatProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DefaultNumericValueProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.MaxMinProperty,
      Properties.NumericFormatProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DefaultNumericValueProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.WidthProperty,
      Properties.MaxMinProperty,
      Properties.NumericFormatProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Label: {
    template: [
      Properties.FontSizeProperty,
      Properties.FontWeightProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.VisibilityRulesProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [Properties.FontSizeProperty, Properties.FontWeightProperty, Properties.LabelProperty]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [Properties.FontSizeProperty, Properties.FontWeightProperty, Properties.LabelProperty]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  RadioButton: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.IsEditableProperty,
      Properties.DatasetProperty,
      Properties.DefaultListValueProperty,
      Properties.ParentFieldNameProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.HorizontalDisplayProperty,
      Properties.EnableClearProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DatasetProperty,
      Properties.DefaultListValueProperty,
      Properties.ParentFieldNameProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.LabelProperty,
      Properties.HorizontalDisplayProperty,
      Properties.EnableClearProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DatasetProperty,
      Properties.DefaultListValueProperty,
      Properties.ParentFieldNameProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.WidthProperty,
      Properties.LabelProperty,
      Properties.HorizontalDisplayProperty,
      Properties.EnableClearProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Section: {
    template: [
      Properties.FontSizeProperty,
      Properties.FontWeightProperty,
      Properties.PaddingProperty,
      Properties.MarginProperty,
      Properties.VisibilityRulesProperty,
      Properties.IsTabProperty,
      Properties.TabColorProperty,
      Properties.TabTextColorProperty,
      Properties.StageStepProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  PeoplePicker: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.SelectionModeProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.SelectionModeProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.SelectionModeProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.LabelProperty,
      Properties.WidthProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  GroupPicker: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.SelectionModeProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.SelectionModeProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.SelectionModeProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.WidthProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  BusinessUnit: {
    template: [
      Properties.IsDetailProperty,
      Properties.ActionIdProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.HintProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.BUFilterOverrideProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.ActionIdProperty,
      Properties.TrackLastUpdateProperty,
      Properties.HintProperty,
      Properties.BUFilterOverrideProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.ActionIdProperty,
      Properties.TrackLastUpdateProperty,
      Properties.HintProperty,
      Properties.BUFilterOverrideProperty,
      Properties.WidthProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Date: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.IsEditableProperty,
      Properties.ExpressionProperty,
      Properties.WeekDaysOnlyProperty,
      Properties.RevisionCountProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.ExpressionProperty,
      Properties.WeekDaysOnlyProperty,
      Properties.RevisionCountProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.ExpressionProperty,
      Properties.WeekDaysOnlyProperty,
      Properties.RevisionCountProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.WidthProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Time: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.IsEditableProperty,
      Properties.DefaultDateTimeProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DefaultDateTimeProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DefaultDateTimeProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.WidthProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Checkbox: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.WidthProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  CheckboxGroup: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.IsEditableProperty,
      Properties.DisplayNameHorizontallyProperty,
      Properties.DatasetProperty,
      Properties.ParentFieldNameProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.ExclusionFilterProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DatasetProperty,
      Properties.ParentFieldNameProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.ExclusionFilterProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DatasetProperty,
      Properties.ParentFieldNameProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.WidthProperty,
      Properties.ExclusionFilterProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  DateTime: {
    template: [
      Properties.ExpressionProperty,
      Properties.HintProperty,
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.DisplayNameHorizontallyProperty,
      Properties.IsEditableProperty,
      Properties.WeekDaysOnlyProperty,
      Properties.RevisionCountProperty,
      Properties.HoursOnlyProperty,
      Properties.VisibilityRulesProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.ExpressionProperty,
      Properties.TrackLastUpdateProperty,
      Properties.HintProperty,
      Properties.IsRequiredProperty,
      Properties.WeekDaysOnlyProperty,
      Properties.RevisionCountProperty,
      Properties.HoursOnlyProperty,
      Properties.VisibilityRulesProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.ExpressionProperty,
      Properties.TrackLastUpdateProperty,
      Properties.HintProperty,
      Properties.IsRequiredProperty,
      Properties.WeekDaysOnlyProperty,
      Properties.RevisionCountProperty,
      Properties.HoursOnlyProperty,
      Properties.VisibilityRulesProperty,
      Properties.WidthProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Calculated: {
    template: [
      Properties.IsDetailProperty,
      Properties.ExpressionProperty,
      Properties.TrackLastUpdateProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.NonZeroingHideProperty,
      Properties.LabelProperty,
      Properties.IsReadOnlyProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.ExpressionProperty,
      Properties.TrackLastUpdateProperty,
      Properties.ConditionalFormattingProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.LabelProperty,
      Properties.IsReadOnlyProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.ExpressionProperty,
      Properties.TrackLastUpdateProperty,
      Properties.ConditionalFormattingProperty,
      Properties.HintProperty,
      Properties.LabelProperty,
      Properties.WidthProperty,
      Properties.IsReadOnlyProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Gallery: {
    template: [
      Properties.DataProperty,
      Properties.FieldsProperty,
      Properties.ParentFieldNameProperty,
      Properties.VisibilityRulesProperty,
      Properties.ExclusionFilterProperty,
      Properties.HideColumnProperty,
      Properties.HeightProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Table: {
    template: [
      Properties.VisibilityRulesProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.ColumnsProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  FileUpload: {
    template: [
      Properties.TrackLastUpdateProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.HintProperty,
      Properties.VisibilityRulesProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: []
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  ImageLabel: {
    template: [
      Properties.ImageSrcProperty,
      Properties.ImageWidthProperty,
      Properties.ImageHeightProperty,
      Properties.LabelProperty,
      Properties.VisibilityRulesProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.ImageSrcProperty,
      Properties.ImageWidthProperty,
      Properties.ImageHeightProperty,
      Properties.LabelProperty,
      Properties.VisibilityRulesProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.ImageSrcProperty,
      Properties.ImageWidthProperty,
      Properties.ImageHeightProperty,
      Properties.LabelProperty,
      Properties.VisibilityRulesProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Hyperlink: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.LabelProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.HintProperty,
      Properties.VisibilityRulesProperty,
      Properties.WidthProperty,
      Properties.LabelProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Index: {
    template: [
      Properties.PrefixProperty,
      Properties.FontSizeProperty,
      Properties.FontWeightProperty,
      Properties.PaddingProperty,
      Properties.ViewEntryColumnWidthProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  TableIndex: {
    table: [Properties.PrefixProperty, Properties.FontSizeProperty, Properties.FontWeightProperty]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Button: {
    template: [
      Properties.AutomationProperty,
      Properties.LabelProperty,
      Properties.VisibilityRulesProperty,
      Properties.IsReadOnlyProperty,
      Properties.TrackLastUpdateProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.AutomationProperty,
      Properties.LabelProperty,
      Properties.VisibilityRulesProperty,
      Properties.TrackLastUpdateProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.AutomationProperty,
      Properties.LabelProperty,
      Properties.VisibilityRulesProperty,
      Properties.WidthProperty,
      Properties.TrackLastUpdateProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  ContinuousComments: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.DisplayNameHorizontallyProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.MaxLengthProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.EnableCommentActionsProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
  Signature: {
    template: [
      Properties.IsDetailProperty,
      Properties.IsRequiredProperty,
      Properties.IsReadOnlyProperty,
      Properties.DisplayNameHorizontallyProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
      Properties.HideColumnProperty,
      Properties.ViewEntryColumnWidthProperty,
      Properties.TrackLastUpdateProperty,
      Properties.FieldInformationProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    gallery: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.VisibilityRulesProperty,
      Properties.HintProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
    table: [
      Properties.IsRequiredProperty,
      Properties.TrackLastUpdateProperty,
      Properties.HintProperty,
      Properties.VisibilityRulesProperty,
      Properties.WidthProperty,
    ]
      .sort((a, b) => a.propertyName.localeCompare(b.propertyName))
      .sort((a, b) => a.propertyCategory.localeCompare(b.propertyCategory)),
  },
};
